import React from 'react';
import PropTypes from 'prop-types';
import PermissionFlag from './PermissionFlag';
import ParamsPermissionFlags from './ParamsPermissionFlags';
import PermissionControls from './PermissionControls';

export default function Permission({ permission, project, inputNamePrefix, updatePermission, deletePermission }) {
  const updateFlag = (flagName, flagValue) => {
    updatePermission(permission.id, flagName, flagValue)
  }

  const handleDelete = () => {
    deletePermission(permission.id)
  }

  return (
    <tr className="project-permission">
      <td>
        <span> {project.name} </span>
        <input name={inputNamePrefix + "[project_id]"} type="hidden" value={permission.project_id} />
      </td>
      {PermissionControls({
        permission,
        inputNamePrefix,
        updateFlag,
      })}
      <td className="tags-remove">
        <a title="Remove"
          className="text-danger"
          tabIndex="-1"
          onClick={handleDelete}>
          <i className="icon-cross3" tabIndex="-1"></i>
          Remove
        </a>
      </td>
    </tr>
  );
}

Permission.propTypes = {
  permission: PropTypes.any.isRequired,
  project: PropTypes.any.isRequired,
  inputNamePrefix: PropTypes.string.isRequired,
  updatePermission: PropTypes.func.isRequired,
  deletePermission: PropTypes.func.isRequired
};
